export default "__VITE_ASSET__93cf36f6__"